/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_No_Projects_Try_Adjust_SearchInputs */



/**
* | output |
* | --- |
* | "Try adjusting your search terms" |
*
* @param {Projects_No_Projects_Try_Adjust_SearchInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const projects_no_projects_try_adjust_search = /** @type {((inputs?: Projects_No_Projects_Try_Adjust_SearchInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_No_Projects_Try_Adjust_SearchInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Versuche, deine Suchbegriffe anzupassen")
	return /** @type {LocalizedString} */ ("Try adjusting your search terms")
});